import { Space } from '@procurify/ui'

import { type ConversationDetailChipsBlock } from '../../value-objects/ConversationTurnItem'
import { ConversationChip } from '../ConversationChip'

export interface ICatalogItemDetailsChipsBlockProps {
  block: ConversationDetailChipsBlock
  onChipSelect: (message: string) => void
}

export const CatalogItemDetailsChipsBlock = ({
  block,
  onChipSelect,
}: ICatalogItemDetailsChipsBlockProps) => (
  <Space direction='horizontal' size='small' flexWrap>
    {block.options.map((option) => (
      <ConversationChip
        key={option.label}
        analyticsId='catalog-item-details-quick-reply-chip'
        onClick={() => onChipSelect(option.message)}
      >
        {option.label}
      </ConversationChip>
    ))}
  </Space>
)
